require("!!/Users/edson/projetos_react/anteros-react/node_modules/script-loader/addScript.js")(require("!!/Users/edson/projetos_react/anteros-react/node_modules/raw-loader/index.js!/Users/edson/projetos_react/anteros-react/node_modules/moment/min/moment-with-locales.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/moment/min/moment-with-locales.min.js
// module id = 142
// module chunks = 0